import React from 'react';
import { Box } from '@mui/material';
import {
  AdvancedMarker,
  type AdvancedMarkerProps,
} from '@vis.gl/react-google-maps';
import { MapPinIcon, SelectedMapPinIcon } from '@/static';

type Props = Omit<AdvancedMarkerProps, 'children' | 'position'> & {
  lat: number | string;
  lng: number | string;
  selected?: boolean;
  width?: number;
  height?: number;
  label?: string;
};

export const toMapCoordinate = (value?: number | string | null) => {
  const coordinate = Number(value);

  return Number.isFinite(coordinate) ? coordinate : null;
};

const MapPropertyMarker = ({
  lat,
  lng,
  selected = false,
  width = 40,
  height = 42,
  label,
  ...markerProps
}: Props) => {
  const markerLat = toMapCoordinate(lat);
  const markerLng = toMapCoordinate(lng);
  const PinIcon = selected ? SelectedMapPinIcon : MapPinIcon;

  if (markerLat === null || markerLng === null) return null;

  return (
    <AdvancedMarker
      position={{ lat: markerLat, lng: markerLng }}
      zIndex={selected ? 20 : 10}
      anchorLeft="-50%"
      anchorTop="-100%"
      {...markerProps}
    >
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <Box
          sx={{
            display: 'block',
            width,
            height,
            transform: selected ? 'scale(1.08)' : 'none',
            transformOrigin: 'bottom center',
          }}
        >
          <PinIcon
            width="100%"
            height="100%"
            style={{
              display: 'block',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          />
        </Box>

        {label && (
          <Box
            sx={{
              position: 'absolute',
              left: '100%',
              top: '50%',
              transform: 'translateY(-50%)',
              ml: 0.75,
              bgcolor: '#fff',
              borderRadius: '4px',
              px: 0.75,
              py: 0.25,
              fontSize: 11,
              fontWeight: 600,
              color: '#000',
              whiteSpace: 'nowrap',
              boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {label}
          </Box>
        )}
      </Box>
    </AdvancedMarker>
  );
};

export default MapPropertyMarker;
